// extracted by mini-css-extract-plugin
export var arrowWrapper = "dS_lb";